import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as jwtDecode from 'jwt-decode';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';
import {Observable} from 'rxjs/Observable';
import * as moment from 'moment';

@Injectable()
export class AuthService {

  private tokenKey = 'bdgr-token';
  private profileKey = 'bdgr-profile';

  private logoutManager: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  public logOut: Observable<any>;

  constructor(private http: HttpClient) {
    this.logOut = this.logoutManager.asObservable();
  }

  isLoggedIn() {
    const token = this.getToken();
    return token && jwtDecode(token).exp * 1000 > Date.now();
  }

  login(data) {
    return this.http.post('/api/login', data)
      .do(res => {
        this.setToken(res['token']);
      });
  }

  register(data) {
    return this.http.post('/api/register', data)
      .do(res => {
        this.setToken(res['token']);
      });
  }

  requestPasswordReset(data) {
    return this.http.post('/api/forgot-password', data);
  }

  resetPassword(data) {
    return this.http.post('/api/reset-password', data);
  }

  changePassword(data) {
    return this.http.post('/api/change-password', data);
  }

  changeCard(data) {
    return this.http.post('/api/change-card', data);
  }

  logout() {
    this.logoutManager.next(true);
    localStorage.removeItem(this.tokenKey);
    localStorage.removeItem(this.profileKey);
  }

  getProfile() {
    return JSON.parse(localStorage.getItem(this.profileKey));
  }

  getToken() {
    return localStorage.getItem(this.tokenKey);
  }

  isAdmin() {
    const token = this.getToken();
    return token && jwtDecode(token).role === 'admin';
  }

  isCurrentUser(userId) {
    return this.getProfile()._id === userId;
  }

  setToken(token) {
    localStorage.setItem(this.tokenKey, token);
    localStorage.setItem(this.profileKey, JSON.stringify(jwtDecode(token)));
  }

  setProfile(profile) {
    localStorage.setItem(this.profileKey, JSON.stringify(profile));
  }

  updateProfile(data) {
    const profile = this.getProfile();
    Object.assign(profile, data);
    this.setProfile(profile);
  }

  populate() {
    return this.http.get('/api/populate');
  }

  reset() {
    return this.http.get('/api/reset');
  }

  isPlanExpired() {
    return moment(this.getProfile().planExpiration).diff(Date.now(), 'days') < 0;
  }

  isTrialPlan() {
    const plan = this.getProfile().plan;
    return plan === 'trial';
  }

  getDaysLeft() {
    return moment(this.getProfile().planExpiration).diff(Date.now(), 'days') + 1;
  }

  subscribe(data) {
    return this.http.post('/api/subscribe', data);
  }

  // hasRights(userId) {
  //   const token = this.getToken();
  //   return token && jwtDecode(token)._id === userId;
  // }

}



// WEBPACK FOOTER //
// ./client/app/core/auth/auth.service.ts